import axios from 'axios'
import { ref } from 'vue'
import { useToast } from 'vue-toast-notification'

export function useCenters({
    onArchived = () => {},
    onRestored = () => {},
    onError = () => {},
}) {
    const $toast = useToast()

    const archiving = ref(false)
    const restoring = ref(false)

    const archiveCenter = async (id) => {
        try {
            archiving.value = true
            await axios.delete(`/api/centers/${id}`)
            onArchived()
        } catch (error) {
            onError(error)
        } finally {
            archiving.value = false
        }
    }

    const restoreCenter = async (id) => {
        try {
            restoring.value = true
            await axios.post(`/api/centers/${id}/restore`)
            $toast.success('Centre restauré', {
                position: 'top',
                duration: 5000,
                dismissible: true,
                pauseOnHover: true,
            })
            onRestored()
        } catch (error) {
            onError(error)
        } finally {
            restoring.value = false
        }
    }

    return {
        archiving,
        restoring,
        archiveCenter,
        restoreCenter,
    }
}
